import * as React from 'react';
import cn from 'classnames';
import Loader from './Loader';

export enum ButtonVariant {
  Default = 'default',
  Ghost = 'ghost',
}

interface ButtonProps {
  id?: string;
  label?: string;
  variant: ButtonVariant;
  disabled?: boolean | undefined;
  className?: string;
  onClick?: (evt: React.MouseEvent<HTMLButtonElement>) => void;
  loading?: boolean;
  icon?: JSX.Element | null;
  leftIcon?: JSX.Element | null;
  dataTestId?: string;
}

export const Button: React.FC<ButtonProps> = ({
  id,
  label,
  variant,
  disabled,
  className,
  onClick,
  loading,
  icon,
  leftIcon,
  dataTestId = 'button',
}) => {
  const cls = cn('border rounded-full p-2 pl-4 pr-4 text-sm', {
    'bg-purple-normal text-white':
      variant === ButtonVariant.Default && !disabled,
    'border-gray-light': variant === ButtonVariant.Ghost,
    'border-gray-light bg-gray-400 text-white': disabled,
  });
  return (
    <button
      id={id}
      data-tip
      data-for={id}
      className={cn(className, cls)}
      disabled={disabled || loading}
      onClick={onClick}
      data-test-id={dataTestId}
    >
      {loading ? (
        <div className='flex justify-center'>
          <Loader />
        </div>
      ) : (
        <div className='font-medium'>
          {leftIcon}
          {label}
          {icon}
        </div>
      )}
    </button>
  );
};
